interface GenreTagged {
    genre: string | null
}

/**
 * Saved artists are oldest-first. Display them newest-first, with every
 * artist of a genre in one leading block and unmatched artists after that.
 */
export function arrangeInfluenceArtists<T extends GenreTagged>(oldestFirst: T[]): T[] {
    const groups = new Map<string, T[]>();
    const groupOrder: string[] = [];
    const loose: T[] = [];
    [...oldestFirst].reverse().forEach((artist) => {
        const genre = artist.genre?.trim();
        if (!genre) {
            loose.push(artist);
            return;
        }
        const members = groups.get(genre);
        if (members) members.push(artist);
        else {
            groups.set(genre, [artist]);
            groupOrder.push(genre);
        }
    });
    return [
        ...groupOrder.flatMap((genre) => groups.get(genre) || []),
        ...loose,
    ];
}
